import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.png";

export const teamCymruScout = defineConnector({
  identifier: "teamCymruScout",
  name: "Team Cymru Scout",
  tagLine: "Threat intelligence and attack surface management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://scout\\.cymru\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Team Cymru Scout](https://scout.cymru.com), go to the **API Keys** page and click **Create** to generate a new API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://scout.cymru.com/api/v1/usage",
  },
});
